import { getRoot } from 'mobx-easy';
import { ExtendedFloatingInventory, FloatingInventoryHistory, FloatingInventoryOwnerType } from '@bringg/types';

import { RootStore } from 'bringg-web';
import { getOwnerType } from '../consts/floating-inventories.utils';

const fetchDrivers = async (userIds: number[]) => {
	if (userIds.length) {
		await getRoot<RootStore>().data.driversStore.loadMany(userIds);
	}
};

const fetch = async (floatingInventories: ExtendedFloatingInventory[] | FloatingInventoryHistory[]) => {
	const userIds = floatingInventories.reduce<number[]>((acc, inventory) => {
		const ownerType =
			'owner_type' in inventory
				? inventory.owner_type
				: getOwnerType({ userId: inventory.user_id, teamId: inventory.team_id });

		if (ownerType === FloatingInventoryOwnerType.DRIVER) {
			acc.push(inventory.user_id);
		}

		return acc;
	}, []);

	await fetchDrivers(userIds);
};

export const extraDataProvider = { fetch };
